import { render } from "./CreateProductStepTwo.vue?vue&type=template&id=95b85a50"
import script from "./CreateProductStepTwo.vue?vue&type=script&lang=js"
export * from "./CreateProductStepTwo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__